import { isInViewport } from '@saviynt/common';

import { flattenList } from '../../../utils/utils';
import {
  EO_FIXED_COL_FOR_ACCOUNT,
  EO_FIXED_COL_FOR_CHILD_ENTITLEMENT,
  EO_FIXED_COL_FOR_ENTITLEMENT,
} from '../../ViewControls/ColumnsFilter/constant';

import {
  CERT_ENTITLEMENT_VALUEKEY,
  CERT_EO_CAMPAIGN_ROW_TYPE,
  CERT_RO_CAMPAIGN_ROW_TYPE,
  CERT_TILE_TYPE,
  FIXED_COL_FOR_ACCOUNT,
  FIXED_COL_FOR_CHILD_ENTITLEMENT,
  FIXED_COL_FOR_ENTITLEMENT,
  FIXED_COL_FOR_ROLE,
  FIXED_COL_FOR_USER,
} from './constant';

export const getCertKind = (tileNodeData) => {
  const certsKeyValue = tileNodeData?.CERT_ENTITLEMENT_VALUEKEY;

  if (certsKeyValue === CERT_ENTITLEMENT_VALUEKEY.USER)
    return CERT_TILE_TYPE.USER;
  if (certsKeyValue === CERT_ENTITLEMENT_VALUEKEY.ROLE)
    return CERT_TILE_TYPE.ROLE;
  if (certsKeyValue === CERT_ENTITLEMENT_VALUEKEY.ACCOUNT)
    return CERT_TILE_TYPE.ACCOUNT;

  return CERT_TILE_TYPE.ENTITLEMENT;
};

export const getEOCertKind = (tileNodeData, iconKind) => {
  const certsKeyValue = tileNodeData?.ROW_TYPE?.toString();

  if (certsKeyValue === CERT_EO_CAMPAIGN_ROW_TYPE.ACCOUNT)
    return CERT_TILE_TYPE.ACCOUNT;
  if (certsKeyValue === CERT_EO_CAMPAIGN_ROW_TYPE.ENTITLEMENT)
    return CERT_TILE_TYPE.ENTITLEMENT;
  if (certsKeyValue === CERT_EO_CAMPAIGN_ROW_TYPE.CHILD_ENTITLEMENT)
    return iconKind
      ? CERT_TILE_TYPE.ENTITLEMENT
      : CERT_TILE_TYPE.CHILD_ENTITLEMENT;

  return CERT_TILE_TYPE.ENTITLEMENT;
};

export const getROCertKind = (tileNodeData) => {
  const certsKeyValue = tileNodeData?.ROW_TYPE?.toString();

  if (certsKeyValue === CERT_RO_CAMPAIGN_ROW_TYPE.ROLE)
    return CERT_TILE_TYPE.ROLE;
  if (certsKeyValue === CERT_RO_CAMPAIGN_ROW_TYPE.USER)
    return CERT_TILE_TYPE.USER;
  if (certsKeyValue === CERT_EO_CAMPAIGN_ROW_TYPE.ENTITLEMENT)
    return CERT_TILE_TYPE.ENTITLEMENT;

  return CERT_TILE_TYPE.ENTITLEMENT;
};

export const getFixedColKey = (certsKind) => {
  if (certsKind === CERT_TILE_TYPE.USER) return FIXED_COL_FOR_USER;
  if (certsKind === CERT_TILE_TYPE.ACCOUNT) return FIXED_COL_FOR_ACCOUNT;
  if (certsKind === CERT_TILE_TYPE.ENTITLEMENT)
    return FIXED_COL_FOR_ENTITLEMENT;
  if (certsKind === CERT_TILE_TYPE.ROLE) return FIXED_COL_FOR_ROLE;

  if (certsKind === CERT_TILE_TYPE.CHILD_ENTITLEMENT)
    return FIXED_COL_FOR_CHILD_ENTITLEMENT;

  return null;
};

export const getEOFixedColKey = (certsKind) => {
  if (certsKind === CERT_TILE_TYPE.ACCOUNT) return EO_FIXED_COL_FOR_ACCOUNT;
  if (certsKind === CERT_TILE_TYPE.ENTITLEMENT)
    return EO_FIXED_COL_FOR_ENTITLEMENT;

  if (certsKind === CERT_TILE_TYPE.CHILD_ENTITLEMENT)
    return EO_FIXED_COL_FOR_CHILD_ENTITLEMENT;

  return null;
};

export const getROFixedColKey = (certsKind) => {
  if (certsKind === CERT_TILE_TYPE.ROLE) return FIXED_COL_FOR_ROLE;
  if (certsKind === CERT_TILE_TYPE.ENTITLEMENT)
    return FIXED_COL_FOR_ENTITLEMENT;

  if (certsKind === CERT_TILE_TYPE.USER) return FIXED_COL_FOR_USER;

  return null;
};

export const TITLE_COL_MESSAGE_KEYS = {
  [FIXED_COL_FOR_USER]: `${FIXED_COL_FOR_USER}.ATTESTATIONS`,
  [FIXED_COL_FOR_ACCOUNT]: `${FIXED_COL_FOR_ACCOUNT}.ATTESTATIONS`,
  [FIXED_COL_FOR_ENTITLEMENT]: `${FIXED_COL_FOR_ENTITLEMENT}.ATTESTATIONS`,
  [FIXED_COL_FOR_ROLE]: `${FIXED_COL_FOR_ROLE}.ATTESTATIONS`,
  [FIXED_COL_FOR_CHILD_ENTITLEMENT]: `${FIXED_COL_FOR_CHILD_ENTITLEMENT}.ATTESTATIONS`,
  [EO_FIXED_COL_FOR_ACCOUNT]: `${FIXED_COL_FOR_ACCOUNT}.ATTESTATIONS`,
  [EO_FIXED_COL_FOR_ENTITLEMENT]: `${FIXED_COL_FOR_ENTITLEMENT}.ATTESTATIONS`,
  [EO_FIXED_COL_FOR_CHILD_ENTITLEMENT]: `${FIXED_COL_FOR_CHILD_ENTITLEMENT}.ATTESTATIONS`,
};

export const disableAllConnectedBar = (prev) =>
  prev.map((item) => ({
    ...item,
    tracker: {
      ...item.tracker,
      isConnected: false,
    },
    children:
      item?.children?.length > 0 ? disableAllConnectedBar(item.children) : [],
  }));

export const toggleConnectedTiles = (previousTiles, targetId, targetLevel) => {
  // First, disable connection status for all tiles except for the targeted one
  const modifiedTiles = disableAllConnectedBar(previousTiles).map((tile) => {
    if (tile.tracker.level === targetLevel) {
      // Enable connection only if the current tile matches the target ID
      const isConnected = tile.tracker.id === targetId;

      return {
        ...tile,
        tracker: {
          ...tile.tracker,
          isConnected,
        },
      };
    }

    // If not on the target level, recursively adjust the connection status of children
    return {
      ...tile,
      tracker: {
        ...tile.tracker,
        isConnected: false, // Default to false as they are not on the target level
      },
      children: tile.children
        ? toggleConnectedTiles(tile.children, targetId, targetLevel)
        : [],
    };
  });

  return modifiedTiles;
};

export const markChildrenAsParent = (children, targetStatus) =>
  children.map((child) => ({
    ...child,
    tracker: {
      ...child.tracker,
      isChecked: targetStatus,
      isIndeterminate: false,
    },
    children:
      child?.children?.length > 0
        ? markChildrenAsParent(child.children, targetStatus)
        : [],
  }));

export const getAllChildStatus = (nodes) => {
  const flattenedList = flattenList(nodes);

  return flattenedList.map(
    (node) => node?.tracker?.isChecked || node?.tracker?.isIndeterminate
  );
};

export const markParentBasedOnChildren = (prev) =>
  prev.map((item) => {
    const hasChildren = item?.children?.length > 0;

    if (!hasChildren) return item;
    // first is parent status
    const childrenStatus = getAllChildStatus(item?.children);
    const isAtleastOneChildChecked = childrenStatus.some(
      (value) => value === true
    );

    if (isAtleastOneChildChecked) {
      return {
        ...item,
        tracker: {
          ...item.tracker,
          isAtleastOneChildChecked,
          isIndeterminate: !item?.tracker?.isChecked,
        },
        children: hasChildren ? markParentBasedOnChildren(item.children) : [],
      };
    }

    return {
      ...item,
      tracker: {
        ...item.tracker,
        isAtleastOneChildChecked,
        isIndeterminate: false,
      },
      children: hasChildren ? markParentBasedOnChildren(item.children) : [],
    };
  });

export const getLoadingFlag = (actions) => {
  if (!actions) return false;

  const trackerActions = Object.keys(actions);
  const flag = Boolean(
    trackerActions.length > 0 &&
      trackerActions?.some((key) => {
        if (actions[key].isLoading) {
          return true;
        }

        return false;
      })
  );

  return flag;
};

const checkDivPosition = (divRef) => {
  const divRect = divRef.current.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  const distanceToBottom = viewportHeight - divRect.bottom;

  // Check if the element is partially obstructed by the footer (128px from the bottom)
  return distanceToBottom < 128;
};

export const scrollToSelectedTile = (tileRef) => {
  if (!tileRef.current) return;

  // Check if the tile is in the viewport and if it's partially obstructed
  const isNodeInView = isInViewport(tileRef.current);
  const divIsVisible = !checkDivPosition(tileRef);

  // Scroll if the tile is not in the viewport or partially obstructed
  if (!isNodeInView || !divIsVisible) {
    tileRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'end',
      inline: 'nearest',
    });
  }
};
